module.exports = __webpack_public_path__ + "img/ckja2.10274605.jpeg";